import React, { useEffect, useState } from 'react'

import { CircularProgress, Dialog, DialogContent } from '@mui/material';
import moment from 'moment';
import { Search } from '@mui/icons-material';




function JobSearchForm( { filter, setFilter}) {

    const [dialogStatus,setDialogStatus]  = useState(false);
    const [searchingInProgress, setSearchingStatus] = useState(false);
    const [srNo,setSrNo] = useState("");
    const [product,setProduct] = useState("");
    const [customerId,setCustomerId] = useState("");

    const handleSrNoChange = (e)=>{
        if (e.key === 'Enter') {
            handleSubmit();
        }
    }

    const handleSubmit = () =>{
        setFilter({"srNo":srNo});
    }
    

    return (
        <div class="input-group mb-3">
            <input type="text" className="form-control" placeholder="Search Sr. No." onChange={(e)=>setSrNo(e.target.value)} onKeyUp={handleSrNoChange} value={srNo}  />
            <button className="btn btn-outline-primary float-end" type="button" onClick={handleSubmit}> <Search/></button>
        </div>
    )
}

export default JobSearchForm



/*

<button className='btn btn-outline-primary' onClick={()=>setDialogStatus(true)} >
                <Search/> Search {JSON.stringify(filter)}
            </button>
            <Dialog
                open={dialogStatus}
                keepMounted
                onClose={()=>{setDialogStatus(false)}}
                fullWidth={true}
                maxWidth="md"
            >
                <DialogContent>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-floating mb-3">
                                <input type="text" className="form-control" placeholder="Enter Sr No" onChange={(e)=>setSrNo(e.target.value)} value={srNo}  />
                                <label>Sr No</label>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <button className="btn btn-outline-primary float-end" type="button" onClick={handleSubmit}> <Search/> Search</button>
                        </div>
                    </div>
                    
                </DialogContent>
            </Dialog>


*/